import React from 'react';
import PropTypes from 'prop-types';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ReferenceLine, ReferenceDot, Label } from 'recharts';
import { renderKr, renderLocaleDate } from 'utils/renderingService';
import { calulateOpsparingSum, sortScrapesByDate } from 'utils/scrapeUtils';
import theme from 'theme';
import defaultData from '../../../api/klatpensionDefaultResponse';

const PensionKlatpensionGraph = ({ data, firstTitle, secondaryTitle, ...props }) => {
    const toKr = (value, small) => value && `${renderKr(value, undefined, undefined, undefined, small === true)}`;
    const toKrTooltip = (value, name) => value && `${renderKr(value, undefined, undefined, undefined, false)}`;
    const renderAge = (value, props) => (props && props.length && props[0].payload.date ? `${renderLocaleDate(new Date(props[0].payload.date))}, ${Math.floor(value)} år` : `${Math.floor(value)} år`);

    const graphData = data ? data.savingsTimeSeries : defaultData.savingsTimeSeries;
    if(!graphData || !graphData.length ){
        return null;
    }
    const todayValue = graphData[0].before;
    const lastValue = graphData[graphData.length - 1].after;
    const lastAge = graphData[graphData.length - 1].age;
    const firstZero = graphData.find(x => x.before === 0);
    const CustomizedYAxisTick = props => {
        const { x, y, payload } = props;
        return (
            <g transform={ `translate(${x},${y})` }>
                <text x={ 0 } y={ 0 } dx={ -20 } textAnchor="end" style={{ fontWeight: 'bold' }}>
                    { payload.value === 0? '0 kr.' : toKr(payload.value) }
                </text>
                { payload.value === 0 ? null : payload.value === todayValue ? (
                    <text x={ 0 } y={ 0 } dx={ -20 } dy={ 20 } textAnchor="end" style={{ fontSize: 12 }}>
                        Opsparet til dato
                    </text>
                ) : (
                    <>
                        <text x={ 0 } y={ 0 } dx={ -20 } dy={ 20 } textAnchor="end" style={{ fontSize: 12 }}>
                            Opsparet ved
                        </text>
                        <text x={ 0 } y={ 0 } dx={ -48 } dy={ 34 } textAnchor="end" style={{ fontSize: 12 }}>
                            pension
                        </text>
                    </>
                ) }
            </g>
        );
    };
    return (
        <ResponsiveContainer width="100%" height="100%">
            <LineChart
                data={ graphData }
                margin={{
                    top: 30,
                    right: 30,
                    left: 20,
                    bottom: 20,
                }}
            >
                <XAxis scale="auto" axisLine={ false } tickLine={ false } dataKey="age" tick={{ dy: 20 }} tickFormatter={ renderAge } minTickGap={ 20 } interval="preserveStartEnd" />
                <YAxis tick={ <CustomizedYAxisTick /> } axisLine={ false } tickLine={ false } ticks={ [0, todayValue, lastValue] } width={ 120 } type="number" domain={ [0, lastValue] } />
                <CartesianGrid horizontal={ false } stroke={ '#D3D3D3' } />
                <Tooltip formatter={ toKrTooltip } labelFormatter={ renderAge } />
                <Legend iconType="plainline" iconSize={ 20 } wrapperStyle={{ transform: 'translate(0, 30px)' }} />
                <ReferenceLine y={ lastValue } stroke={ '#D3D3D3' } strokeWidth={ 3 } />
                { firstZero && <ReferenceLine x={ firstZero.age } stroke={ '#ffbfbf' } strokeWidth={ 2 } /> }

                <ReferenceLine x={ lastAge } stroke={ theme.palette.secondary.main } strokeWidth={ 3 } label={ <Label value="Pension" position="insideTop" offset={ -20 } /> } />
                <Line dot={ false } type="monotone" dataKey="before" strokeWidth={ 3 } stroke={ '#da5b5b' } name={ firstTitle } />
                <Line dot={ false } type="monotone" dataKey="after" strokeWidth={ 3 } stroke={ '#499f56' } name={ secondaryTitle } />
            </LineChart>
        </ResponsiveContainer>
    );
};

PensionKlatpensionGraph.defaultProps = {};

PensionKlatpensionGraph.propTypes = {};

export default PensionKlatpensionGraph;
